// extracted by mini-css-extract-plugin
export default {"root":"button-module__root___dMJqh","toggled":"button-module__toggled___C5DnX","spinner":"button-module__spinner___JQ3hA"};